import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

/**
 * GoldWipe Transition
 * - Premium transition for checkout, wallet, VIP pages
 * - Gold gradient wipes from right to left
 * - Reveals new page behind it
 * - Duration: 600ms
 * - Leaves gold shimmer trail
 */

const GoldWipe = ({ children, isReady }) => {
  const [showWipe, setShowWipe] = useState(true);

  useEffect(() => {
    // Hide wipe overlay after animation completes
    const timer = setTimeout(() => {
      setShowWipe(false);
    }, 700);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Gold Wipe Overlay */}
      {showWipe && (
        <motion.div
          className="gold-wipe-overlay"
          initial={{ x: "100%" }}
          animate={{ x: "-100%" }}
          transition={{
            duration: 0.6,
            ease: [0.76, 0, 0.24, 1], // Smooth expo easing
          }}
        >
          {/* Primary gold layer */}
          <div className="gold-wipe-layer gold-wipe-primary" />

          {/* Shimmer layer */}
          <div className="gold-wipe-layer gold-wipe-shimmer" />

          {/* Trailing sparkles */}
          <div className="gold-wipe-sparkles">
            {[...Array(12)].map((_, i) => (
              <motion.div
                key={i}
                className="gold-sparkle"
                initial={{
                  scale: 0,
                  opacity: 0,
                  x: Math.random() * 100 - 50,
                  y: Math.random() * window.innerHeight
                }}
                animate={{
                  scale: [0, 1, 0],
                  opacity: [0, 1, 0],
                }}
                transition={{
                  duration: 0.8,
                  delay: i * 0.05,
                  ease: "easeInOut"
                }}
              />
            ))}
          </div>
        </motion.div>
      )}

      {/* Page Content */}
      <motion.div
        className="page-transition-container"
        initial={{
          opacity: 0,
          scale: 0.98
        }}
        animate={{
          opacity: isReady ? 1 : 0.9,
          scale: 1
        }}
        exit={{
          opacity: 0,
          scale: 1.02
        }}
        transition={{
          duration: 0.4,
          delay: 0.2, // Delay so content appears as wipe reveals
          ease: [0.4, 0, 0.2, 1]
        }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default GoldWipe;
